import CustomTab from "@/components/CustomTab";
import React, { useRef } from "react";
import Head from "next/head";
import AnimatedTitleHeader from "@/components/TitleHeader/AnimatedTitleHeader";
import ScrollUpArrow from "@/components/Common/ScrollUpArrow";
import NoIndexMeta from "@/components/Common/NoIndexMeta";
import MetaTags from "@/components/seo/meta-tags";
import Link from "next/link";
import { PHONE_NUMBER_ONE, PHONE_NUMBER_TWO } from "@/constastants/Constant";

const PrivacyPolicy = () => {
  const KeyPoints = [
    {
      key: "1",
      text: "Summary of key points",
    },
    {
      key: "2",
      text: "What information do we have to collect?",
    },
    {
      key: "3",
      text: "How do we process your information?",
    },
    {
      key: "4",
      text: "What information do we have to collect?",
    },
    {
      key: "5",
      text: "What information do we have to collect?",
    },
  ];

  const Content = [
    {
      key: "1",
      data: [
        {
          heading: "Last updated September 5th July, 2022",
          text: (
            <div>
              THIS PRIVACY POLICY IS AN ELECTRONIC RECORD IN THE FORM OF AN
              ELECTRONIC CONTRACT FORMED UNDER THE INFORMATION TECHNOLOGY ACT,
              2000 AND THE RULES MADE THEREUNDER AND THE AMENDED PROVISIONS
              PERTAINING TO ELECTRONIC DOCUMENTS/RECORDS IN VARIOUS STATUTES AS
              AMENDED BY THE INFORMATION TECHNOLOGY ACT, 2000. THIS PRIVACY
              POLICY DOES NOT REQUIRE ANY PHYSICAL, ELECTRONIC OR DIGITAL
              SIGNATURE. THIS PRIVACY POLICY IS A LEGALLY BINDING DOCUMENT
              BETWEEN YOU AND BIZINBIZ TECHNOLOGIES PVT LTD. THE TERMS OF THIS
              PRIVACY POLICY WILL BE EFFECTIVE UPON YOUR ACCEPTANCE OF THE SAME
              (DIRECTLY OR INDIRECTLY IN ELECTRONIC FORM, BY CLICKING ON THE "I
              ACCEPT" TAB OR BY USE OF THE WEBSITE OR BY OTHER MEANS AND WILL
              GOVERN THE RELATIONSHIP BETWEEN YOU AND BIZINBIZ TECHNOLOGIES PVT
              LTD FOR YOUR USE OF THE WEBSITE (DEFINED BELOW). THIS DOCUMENT IS
              PUBLISHED AND SHALL BE CONSTRUED IN ACCORDANCE WITH THE PROVISIONS
              OF THE INFORMATION TECHNOLOGY (REASONABLE SECURITY PRACTICES AND
              PROCEDURES AND SENSITIVE PERSONAL DATA OF INFORMATION) RULES, 2011
              UNDER INFORMATION TECHNOLOGY ACT, 2000; THAT REQUIRE PUBLISHING OF
              THE PRIVACY POLICY FOR COLLECTION, USE, STORAGE AND TRANSFER OF
              SENSITIVE PERSONAL DATA OR INFORMATION. PLEASE READ THIS PRIVACY
              POLICY CAREFULLY. BY USING THE WEBSITE, YOU INDICATE THAT YOU
              UNDERSTAND, AGREE AND CONSENT TO THIS PRIVACY POLICY. THIS POLICY
              IS GLOBAL IN NATURE AND GOVERNS OUR DATA PROTECTION PRACTICES
              WHETHER WE COLLECT YOUR PERSONAL INFORMATION THROUGH OUR WEBSITES,
              APPLICATION SOFTWARE, OR ANY OTHER MEANS. WHEN WE COLLECT
              INFORMATION ABOUT YOU OTHER THAN THE AFOREMENTIONED MEANS, WE WILL
              FIRST OBTAIN YOUR PERMISSION TO DO SO, IF AND AS REQUIRED BY THE
              APPLICABLE LAW. IF YOU DO NOT AGREE WITH THE TERMS OF THIS PRIVACY
              POLICY, PLEASE DO NOT USE THIS WEBSITE. YOU HEREBY PROVIDE YOUR
              UNCONDITIONAL CONSENT OR AGREEMENT TO BIZINBIZ TECHNOLOGIES PVT
              LTD AS PROVIDED UNDER SECTION 43A AND SECTION 72A OF INFORMATION
              TECHNOLOGY ACT, 2000.
            </div>
          ),
        },
        {
          key: "2",
          heading: "SUMMARY OF KEY POINTS",
          text: (
            <div>
              This summary provides key points from our privacy notice, but you
              can find out more details about any of these topics by clicking
              the link following each key point or by using our table of
              contents below to find the section you are looking for. You can
              also click here to go directly to our table of contents. What
              personal information do we process? When you visit, use, or
              navigate our Services, we may process personal information
              depending on how you interact with Elchemy and the Services, the
              choices you make, and the products and features you use. Click
              here to learn more. Do we process any sensitive personal
              information? We do not process sensitive personal information. Do
              we receive any information from third parties? We do not receive
              any information from third parties. How do we process your
              information? We process your information to provide, improve, and
              administer our Services, communicate with you, for security and
              fraud prevention, and comply with the law. We may also process
              your information for other purposes with your consent. We process
              your information only when we have a valid legal reason to do so.
              Click here to learn more. In what situations and with which
              parties do we share personal information? We may share information
              in specific situations and with specific third parties. Click here
              to learn more. How do we keep your information safe? We have
              organizational and technical processes and procedures in place to
              protect your personal information. However, no electronic
              transmission over the internet or information storage technology
              can be guaranteed to be 100% secure, so we cannot promise or
              guarantee that hackers, cybercriminals, or other unauthorized
              third parties will not be able to defeat our security and
              improperly collect, access, steal, or modify your information.
              Click here to learn more. What are your rights? Depending on where
              you are located geographically, the applicable privacy law may
              mean you have certain rights regarding your personal information.
              Click here to learn more. How do you exercise your rights? The
              easiest way to exercise your rights is by filling out our data
              subject request form available here, or by contacting us. We will
              consider and act upon any request in accordance with applicable
              data protection laws. Want to learn more about what Elchemy does
              with any information we collect? Click here to review the notice
              in full.
            </div>
          ),
        },
        {
          key: "3",
          heading: "TABLE OF CONTENTS",
          text: (
            <div>
              1.WHAT INFORMATION DO WE COLLECT?
              <br /> 2. HOW DO WE PROCESS YOUR INFORMATION?
              <br /> 3. WHAT LEGAL BASES DO WE RELY ON TO PROCESS YOUR PERSONAL
              INFORMATION? <br /> 4. WHEN AND WITH WHOM DO WE SHARE YOUR
              PERSONAL INFORMATION?
              <br /> 5. DO WE USE COOKIES AND OTHER TRACKING TECHNOLOGIES?
              <br /> 6. HOW DO WE HANDLE YOUR SOCIAL LOGINS?
              <br /> 7. HOW LONG DO WE KEEP YOUR INFORMATION? <br /> 8. HOW DO
              WE KEEP YOUR INFORMATION SAFE?
              <br /> 9. DO WE COLLECT INFORMATION FROM MINORS? <br /> 10. WHAT
              ARE YOUR PRIVACY RIGHTS?
              <br /> 11. CONTROLS FOR DO-NOT-TRACK FEATURES <br /> 12. DO
              CALIFORNIA RESIDENTS HAVE SPECIFIC PRIVACY RIGHTS? <br /> 13. DO
              WE MAKE UPDATES TO THIS NOTICE?
              <br /> 14. HOW CAN YOU CONTACT US ABOUT THIS NOTICE? <br /> 15.
              HOW CAN YOU REVIEW, UPDATE, OR DELETE THE DATA WE COLLECT FROM
              YOU?
            </div>
          ),
        },
        {
          key: "4",
          heading: "1. WHAT INFORMATION DO WE COLLECT?",
          text: (
            <div>
              <p className="pb-4"> Personal information you disclose to us </p>
              <p className="pb-4">
                In Short: We collect personal information that you provide to
                us. We collect personal information that you voluntarily provide
                to us when you express an interest in obtaining information
                about us or our products and Services, when you participate in
                activities on the Services, or otherwise when you contact us.
              </p>
              <p className="pb-4">
                Personal Information Provided by You. The personal information
                that we collect depends on the context of your interactions with
                us and the Services, the choices you make, and the products and
                features you use. The personal information we collect may
                include the following:
              </p>
              <p className="pb-4">
                Names, email addresses, phone numbers, mailing addresses, Job
                titles, Billing addresses, Contact preferences Sensitive
                Information. We do not process sensitive information.
              </p>
              <p className="pb-4">
                Social Media Login Data. We may provide you with the option to
                register with us using your existing social media account
                details, like your Facebook, Twitter, or other social media
                account. If you choose to register in this way, we will collect
                the information described in the section called "HOW DO WE
                HANDLE YOUR SOCIAL LOGINS?" below.
              </p>
              <p className="pb-4">
                {" "}
                All personal information that you provide to us must be true,
                complete, and accurate, and you must notify us of any changes to
                such personal information.
              </p>{" "}
              <p> Information automatically collected </p>{" "}
              <p className="pb-4">
                In Short: Some information — such as your Internet Protocol (IP)
                address and/or browser and device characteristics — is collected
                automatically when you visit our Services.{" "}
              </p>{" "}
              <p className="pb-4">
                {" "}
                We automatically collect certain information when you visit,
                use, or navigate the Services. This information does not reveal
                your specific identity (like your name or contact information)
                but may include device and usage information, such as your IP
                address, browser and device characteristics, operating system,
                language preferences, referring URLs, device name, country,
                location, information about how and when you use our Services,
                and other technical information. This information is primarily
                needed to maintain the security and operation of our Services,
                and for our internal analytics and reporting purposes.
              </p>
              <p className="pb-4">
                Like many businesses, we also collect information through
                cookies and similar technologies.{" "}
              </p>{" "}
              <p className="pb-4"> The information we collect includes: </p>
              <p className="pb-4">
                Log and Usage Data. Log and usage data is service-related,
                diagnostic, usage, and performance information our servers
                automatically collect when you access or use our Services and
                which we record in log files. Depending on how you interact with
                us, this log data may include your IP address, device
                information, browser type, and settings and information about
                your activity in the Services (such as the date/time stamps
                associated with your usage, pages and files viewed, searches,
                and other actions you take such as which features you use),
                device event information (such as system activity, error reports
                (sometimes called "crash dumps"), and hardware settings).
              </p>
              <p className="pb-4">
                Device Data. We collect device data such as information about
                your computer, phone, tablet, or other device you use to access
                the Services. Depending on the device used, this device data may
                include information such as your IP address (or proxy server),
                device and application identification numbers, location, browser
                type, hardware model, Internet service provider and/or mobile
                carrier, operating system, and system configuration information
              </p>
            </div>
          ),
        },
      ],
    },
  ];
  const parentRef = useRef(null);
  return (
    <>
      <MetaTags title="Privacy Policy" description="Privacy policy" />

      <ScrollUpArrow />

      <>
        <AnimatedTitleHeader
          text={"Privacy Policy"}
          imgSrc={"https://storage.googleapis.com/elchemy-dev/1706593708.png"}
          titleAsH1
        />
        <div className="px-6 md:px-20 py-8">
          <p className="">
            <Link href={"/"} className="text-[0.85rem] text-[#808080]">
              Home
            </Link>{" "}
            <span className="px-1">/</span>{" "}
            <span className="font-medium text-[0.9rem]">Privacy Policy</span>
          </p>
          <div
            className="flex flex-col sm:flex-row justify-between w-full relative pt-[2rem] sm:pt-[3rem]"
            ref={parentRef}
          >
            {/* <div className="w-full sm:w-[75%] min-h-[80vh]">
          {getSelectedData(Content)?.map((data) => {
            return (
              <div>
                <p className=" text-[1rem] mb-6 font-medium">{data?.heading}</p>
                <p className="text-[0.9rem] mb-12 font-light text-[#666666]">
                  {data?.text}
                </p>
              </div>
            );
          })}
        </div> */}
            <div className="w-full sm:w-[75%] min-h-[80vh]">
              <div>
                <p className=" text-[1rem] mb-6 font-medium">
                  Last updated 5th July 2024
                </p>
                <p className="text-[0.9rem] mb-12 font-light text-[#666666]">
                  THIS PRIVACY POLICY IS AN ELECTRONIC RECORD IN THE FORM OF AN
                  ELECTRONIC CONTRACT FORMED UNDER THE INFORMATION TECHNOLOGY
                  ACT, 2000 AND THE RULES MADE THEREUNDER AND THE AMENDED
                  PROVISIONS PERTAINING TO ELECTRONIC DOCUMENTS/RECORDS IN
                  VARIOUS STATUTES AS AMENDED BY THE INFORMATION TECHNOLOGY ACT,
                  2000. THIS PRIVACY POLICY DOES NOT REQUIRE ANY PHYSICAL,
                  ELECTRONIC OR DIGITAL SIGNATURE. THIS PRIVACY POLICY IS A
                  LEGALLY BINDING DOCUMENT BETWEEN YOU AND BIZINBIZ TECHNOLOGIES
                  PVT LTD. THE TERMS OF THIS PRIVACY POLICY WILL BE EFFECTIVE
                  UPON YOUR ACCEPTANCE OF THE SAME (DIRECTLY OR INDIRECTLY IN
                  ELECTRONIC FORM, BY CLICKING ON THE "I ACCEPT" TAB OR BY USE
                  OF THE WEBSITE OR BY OTHER MEANS AND WILL GOVERN THE
                  RELATIONSHIP BETWEEN YOU AND BIZINBIZ TECHNOLOGIES PVT LTD FOR
                  YOUR USE OF THE WEBSITE (DEFINED BELOW). THIS DOCUMENT IS
                  PUBLISHED AND SHALL BE CONSTRUED IN ACCORDANCE WITH THE
                  PROVISIONS OF THE INFORMATION TECHNOLOGY (REASONABLE SECURITY
                  PRACTICES AND PROCEDURES AND SENSITIVE PERSONAL DATA OF
                  INFORMATION) RULES, 2011 UNDER INFORMATION TECHNOLOGY ACT,
                  2000; THAT REQUIRE PUBLISHING OF THE PRIVACY POLICY FOR
                  COLLECTION, USE, STORAGE AND TRANSFER OF SENSITIVE PERSONAL
                  DATA OR INFORMATION. PLEASE READ THIS PRIVACY POLICY
                  CAREFULLY. BY USING THE WEBSITE, YOU INDICATE THAT YOU
                  UNDERSTAND, AGREE AND CONSENT TO THIS PRIVACY POLICY. THIS
                  POLICY IS GLOBAL IN NATURE AND GOVERNS OUR DATA PROTECTION
                  PRACTICES WHETHER WE COLLECT YOUR PERSONAL INFORMATION THROUGH
                  OUR WEBSITES, APPLICATION SOFTWARE, OR ANY OTHER MEANS. WHEN
                  WE COLLECT INFORMATION ABOUT YOU OTHER THAN THE AFOREMENTIONED
                  MEANS, WE WILL FIRST OBTAIN YOUR PERMISSION TO DO SO, IF AND
                  AS REQUIRED BY THE APPLICABLE LAW. IF YOU DO NOT AGREE WITH
                  THE TERMS OF THIS PRIVACY POLICY, PLEASE DO NOT USE THIS
                  WEBSITE. YOU HEREBY PROVIDE YOUR UNCONDITIONAL CONSENT OR
                  AGREEMENT TO BIZINBIZ TECHNOLOGIES PVT LTD AS PROVIDED UNDER
                  SECTION 43A AND SECTION 72A OF INFORMATION TECHNOLOGY ACT,
                  2000.
                </p>
                <p className=" text-[1rem] mb-6 font-medium">
                  BizinBiz Technologies Pvt Ltd (“Elchemy”, “we”, “us”, “our”)
                  is concerned with the privacy of its users (hereinafter
                  referred to as “You”, “Your”, “Yourself”) that frequent its
                  website www.elchemy.com (“Website”). BizinBiz Technologies Pvt
                  Ltd recognizes the importance of privacy as well as the
                  importance of maintaining the confidentiality of your
                  information. This Privacy Policy applies to all products and
                  services provided by us and is drafted to explain to You how
                  BizinBiz Technologies Pvt Ltd collects, uses and discloses
                  your information to relevant entities that are vital to the
                  functioning of this Website. BY USING THIS WEBSITE, YOU AGREE
                  TO THE TERMS AND CONDITIONS OF THIS POLICY. IF YOU DO NOT
                  AGREE WITH THE TERMS AND CONDITIONS OF THIS POLICY, PLEASE DO
                  NOT PROCEED FURTHER TO USE THIS WEBSITE.
                </p>
              </div>
              <div>
                <p className=" text-[1.5rem] mb-6 font-medium uppercase">
                  Elchemy respects Your privacy and has provided this Privacy
                  Policy to familiarise You with:
                </p>
                <ol className="list-decimal">
                  <li>
                    <p className="text-[0.9rem] mb-6 font-light text-[#666666]">
                      The type of data or information that You share with or
                      provide to Elchemy and that Elchemy collects from You;
                    </p>
                  </li>
                  <li>
                    <p className="text-[0.9rem] mb-6 font-light text-[#666666]">
                      The purpose for collection of such data or information
                      from You;
                    </p>
                  </li>
                  <li>
                    <p className="text-[0.9rem] mb-6 font-light text-[#666666]">
                      Elchemy's information security practices and policies;
                    </p>
                  </li>
                  <li>
                    <p className="text-[0.9rem] mb-6 font-light text-[#666666]">
                      Elchemy's policy on sharing or transferring Your data or
                      information with third parties.
                    </p>
                  </li>
                </ol>
                <p className="text-[0.9rem] mb-6 font-light text-[#666666]">
                  We take measures to protect the security of the information
                  provided by You. You can contact Us about Our privacy
                  practices. Our privacy practices may vary among the countries
                  in which We operate to reflect local practices and legal
                  requirements. This Privacy Policy describes Elchemy’s current
                  data protection policies and practices and may be
                  amended/updated from time to time. Upon amending/updating the
                  Privacy Policy, We will accordingly amend the date above and
                  post the revised version behind the link marked “Privacy
                  Policy” in the footer of each page of Elchemy’s websites. We
                  suggest that You regularly check this Privacy Policy to
                  apprise Yourself of any updates. Your continued use of Website
                  or provision of data or information thereafter will imply Your
                  unconditional acceptance of such updates to this Privacy
                  Policy.
                </p>
                <p className=" text-[1rem] mb-2 font-medium">
                  COLLECTION OF INFORMATION
                </p>
                <ol className="list-decimal">
                  <li>
                    <p className="text-[0.9rem] mb-6 font-light text-[#666666]">
                      Your privacy is important to us and we have taken steps to
                      ensure that we do not collect more information from you
                      than is necessary for us to provide you with our services
                      and to protect your account
                    </p>
                  </li>
                  <li>
                    <p className="text-[0.9rem] mb-6 font-light text-[#666666]">
                      Information including, but not limited to, user name,
                      address, phone number, fax number and email address
                      ("Registration Information") may be collected at the time
                      of user registration on the website.
                    </p>
                  </li>
                  <li>
                    <p className="text-[0.9rem] mb-6 font-light text-[#666666]">
                      In connection with any transaction and payment services or
                      services under our buyer protection schemes we provide on
                      the Website, information, including but not limited to,
                      bank account numbers, billing and delivery information,
                      credit/debit card numbers and expiration dates and
                      tracking information from cheques or money orders
                      ("Account Information") may be collected to, among other
                      things, facilitate the sale and purchase as well as the
                      settlement of purchase price of the products or services
                      transacted on or procured through the website.
                    </p>
                  </li>
                  <li>
                    <p className="text-[0.9rem] mb-6 font-light text-[#666666]">
                      We record and retain details of users’ activities on the
                      website. Information relating to such transactions
                      including, but not limited to, the types and
                      specifications of the goods, pricing and delivery
                      information and any trade dispute records (“Activities
                      Information”) may be collected when sale and purchase
                      transactions are conducted on or facilitated through the
                      website.
                    </p>
                  </li>
                  <li>
                    <p className="text-[0.9rem] mb-6 font-light text-[#666666]">
                      We record and retain records of users' buying and browsing
                      activities on our platform including but not limited to IP
                      addresses, browsing patterns and buyer behavioral
                      patterns. In addition, we gather statistical information
                      about the website and visitors to the website including,
                      but not limited to, IP addresses, browser software,
                      operating system, software and hardware attributes, pages
                      viewed, number of sessions and unique visitors (together
                      "Browsing Information").
                    </p>
                  </li>
                  <li>
                    <p className="text-[0.9rem] mb-6 font-light text-[#666666]">
                      Registration Information, Account Information, Activities
                      Information and Browsing Information generally relate to
                      business entities and are together referred to as business
                      (“Business Data”). Insofar and only insofar as they
                      constitute personally identifiable data of living
                      individuals, such information are together referred to as
                      personal data (“Personal Data”).
                    </p>
                  </li>
                  <li>
                    <p className="text-[0.9rem] mb-6 font-light text-[#666666]">
                      We do not store any messages, photos, videos or documents
                      from your chats/emails through our servers.
                    </p>
                  </li>
                </ol>
                <p className=" text-[1rem] mb-2 font-medium">REPRESENTATION</p>
                <ol className="list-decimal">
                  <li>
                    <p className="text-[0.9rem] mb-6 font-light text-[#666666]">
                      You hereby represent to Elchemy that the Information You
                      provide to Elchemy from time to time is and shall be
                      authentic, correct, current and updated and You have all
                      the rights, permissions and consents as may be required to
                      provide such Information to Elchemy.
                    </p>
                  </li>
                  <li>
                    <p className="text-[0.9rem] mb-6 font-light text-[#666666]">
                      Your providing the Information to Elchemy and Elchemy's
                      consequent storage, collection, usage, transfer, access or
                      processing of the same shall not be in violation of any
                      third party agreement, laws, charter documents, judgments,
                      orders and decrees.
                    </p>
                  </li>
                </ol>
                <p className=" text-[1rem] mb-2 font-medium">
                  USE OF TECHNOLOGY
                </p>
                <p className="text-[0.9rem] mb-6 font-light text-[#666666]">
                  Elchemy collects, uses, stores and processes Your Information
                  for any purpose as may be permissible under applicable laws
                  (including where the applicable law provides for such
                  collection, usage, storage or processes in accordance with the
                  consent of the user) including the following (“Purposes”):
                </p>
                <ol className="list-decimal">
                  <li>
                    <p className="text-[0.9rem] mb-6 font-light text-[#666666]">
                      to facilitate Your use of the Website;
                    </p>
                  </li>
                  <li>
                    <p className="text-[0.9rem] mb-6 font-light text-[#666666]">
                      to respond to Your inquiries or fulfil Your requests for
                      information about the various products and services
                      offered on the Website;
                    </p>
                  </li>
                  <li>
                    <p className="text-[0.9rem] mb-6 font-light text-[#666666]">
                      to provide You with information about products and
                      services available on the Website and to send You
                      information, materials, and offers from Elchemy;
                    </p>
                  </li>
                  <li>
                    <p className="text-[0.9rem] mb-6 font-light text-[#666666]">
                      to send You important information regarding the Website,
                      changes in terms and conditions, user agreements, and
                      policies and/or other administrative information;
                    </p>
                  </li>
                  <li>
                    <p className="text-[0.9rem] mb-6 font-light text-[#666666]">
                      to send You surveys and marketing communications that
                      Elchemy believes may be of interest to You;
                    </p>
                  </li>
                  <li>
                    <p className="text-[0.9rem] mb-6 font-light text-[#666666]">
                      to personalize Your experience on the Website by
                      presenting advertisements, products and offers tailored to
                      Your preferences;
                    </p>
                  </li>
                  <li>
                    <p className="text-[0.9rem] mb-6 font-light text-[#666666]">
                      to help You address Your problems incurred on the Website
                      including addressing any technical problems;
                    </p>
                  </li>
                  <li>
                    <p className="text-[0.9rem] mb-6 font-light text-[#666666]">
                      if You purchase any product or avail of any service from
                      the Website, to complete and fulfil Your purchase, for
                      example, to have Your payments processed, communicate with
                      You regarding Your purchase and provide You with related
                      customer service;
                    </p>
                  </li>
                  <li>
                    <p className="text-[0.9rem] mb-6 font-light text-[#666666]">
                      for proper administering of the Website;
                    </p>
                  </li>
                  <li>
                    <p className="text-[0.9rem] mb-6 font-light text-[#666666]">
                      to conduct internal reviews and data analysis for the
                      Website (e.g., to determine the number of visitors to
                      specific pages within the Website);
                    </p>
                  </li>
                  <li>
                    <p className="text-[0.9rem] mb-6 font-light text-[#666666]">
                      to improve the services, content and advertising on the
                      Website;
                    </p>
                  </li>
                  <li>
                    <p className="text-[0.9rem] mb-6 font-light text-[#666666]">
                      to facilitate various programs and initiatives launched by
                      Elchemy or third party service providers and business
                      associates;
                    </p>
                  </li>
                  <li>
                    <p className="text-[0.9rem] mb-6 font-light text-[#666666]">
                      to analyse how our services are used, to measure the
                      effectiveness of advertisements, to facilitating payments;
                    </p>
                  </li>
                  <li>
                    <p className="text-[0.9rem] mb-6 font-light text-[#666666]">
                      to protect the integrity of the Website;
                    </p>
                  </li>
                  <li>
                    <p className="text-[0.9rem] mb-6 font-light text-[#666666]">
                      to respond to legal, judicial, quasi-judicial process and
                      provide information to law enforcement agencies or in
                      connection with an investigation on matters related to
                      public safety, as permitted by law;
                    </p>
                  </li>
                  <li>
                    <p className="text-[0.9rem] mb-6 font-light text-[#666666]">
                      to conduct analytical studies on various aspects including
                      user behaviour, user preferences etc.;
                    </p>
                  </li>
                  <li>
                    <p className="text-[0.9rem] mb-6 font-light text-[#666666]">
                      to permit third parties who may need to contact users who
                      have bought products from the Website to facilitate
                      service and any other product related support;
                    </p>
                  </li>
                  <li>
                    <p className="text-[0.9rem] mb-6 font-light text-[#666666]">
                      to implement information security practices;
                    </p>
                  </li>
                  <li>
                    <p className="text-[0.9rem] mb-6 font-light text-[#666666]">
                      to determine any security breaches, computer contaminant
                      or computer virus;
                    </p>
                  </li>
                  <li>
                    <p className="text-[0.9rem] mb-6 font-light text-[#666666]">
                      to investigate, prevent, or take action regarding illegal
                      activities and suspected fraud;
                    </p>
                  </li>
                  <li>
                    <p className="text-[0.9rem] mb-6 font-light text-[#666666]">
                      to undertake forensics of the concerned computer resource
                      as a part of investigation or internal audit;{" "}
                    </p>
                  </li>
                  <li>
                    <p className="text-[0.9rem] mb-6 font-light text-[#666666]">
                      to trace computer resources or any person who may have
                      contravened, or is suspected of having or being likely to
                      contravene, any provision of law including the Information
                      Technology Act, 2000 that is likely to have an adverse
                      impact on the services provided on any Website or by
                      Elchemy.
                    </p>
                  </li>
                </ol>
                <p className="text-[0.9rem] mb-6 font-light text-[#666666]">
                  You hereby agree and acknowledge that the Information so
                  collected is for lawful purpose connected with a function or
                  activity of Elchemy or any person on our behalf, and the
                  collection of Information is necessary for the Purposes.
                </p>
                <p className=" text-[1rem] mb-2 font-medium">
                  DISCLOSURE OF PERSONAL DATA
                </p>
                <ol className="list-decimal">
                  <li>
                    <p className="text-[0.9rem] mb-6 font-light text-[#666666]">
                      You further agree that we may disclose and transfer your
                      Personal Data to service providers engaged by us to assist
                      us with providing you with our services (including but not
                      limited to data entry, database management, promotions,
                      products and services alerts, delivery services, payment
                      extension services, and membership authentication and
                      verification services) ("Service Providers"). These
                      Service Providers are under a duty of confidentiality to
                      us and are only permitted to use your Personal Data in
                      connection with the purposes specified above, and not for
                      their own purposes (including direct marketing).
                    </p>
                  </li>
                  <li>
                    <p className="text-[0.9rem] mb-6 font-light text-[#666666]">
                      When necessary we may also disclose and transfer your
                      Personal Data to our professional advisers, law
                      enforcement agencies, insurers, government and regulatory
                      and other organizations for the purposes specified at B.9
                      above.
                    </p>
                  </li>
                  <li>
                    <p className="text-[0.9rem] mb-6 font-light text-[#666666]">
                      Any Personal Data supplied by you will be retained by us
                      and will be accessible by our employees, any Service
                      Providers engaged by us and third parties referred to
                      above, for or in relation to any of the Purposes.
                    </p>
                  </li>
                  <li>
                    <p className="text-[0.9rem] mb-6 font-light text-[#666666]">
                      All Voluntary Information may be made publicly available
                      on the website and therefore accessible by any internet
                      user. Any Voluntary Information that you disclose to us
                      becomes public information and you relinquish any
                      proprietary rights (including but not limited to the
                      rights of confidentiality and copyright) in such
                      information. You should exercise caution when deciding to
                      include personal or proprietary information in the
                      Voluntary Information that you submit to us.
                    </p>
                  </li>
                  <li>
                    <p className="text-[0.9rem] mb-6 font-light text-[#666666]">
                      We may share your Account Information with banks or
                      vendors to enable your transactions on the website to be
                      completed. In addition, we may use your Account
                      Information to determine your creditworthiness and, in the
                      process of such determination, we may need to make such
                      Account Information available to banks or credit agencies.
                      While we have in place up-to-date technology and internal
                      procedures to keep your Account Information and other
                      Personal Data secure from intruders, there is no guarantee
                      that such technology or procedures can eliminate all of
                      the risks of theft, loss or misuse.
                    </p>
                  </li>
                  <li>
                    <p className="text-[0.9rem] mb-6 font-light text-[#666666]">
                      We may provide statistical information to third parties,
                      but when we do so, we do not provide
                      personally-identifying information without your
                      permission.
                    </p>
                  </li>
                </ol>

                <p className=" text-[1rem] mb-2 font-medium">COOKIES</p>
                <p className="text-[0.9rem] mb-6 font-light text-[#666666]">
                  We use "cookies" to store specific information about you and
                  track your visits to the website. It is not uncommon for
                  websites to use cookies to enhance identification of their
                  users.A "cookie" is a small amount of data that is sent to
                  your browser and stored on your computer's hard drive. A
                  cookie can be sent to your computer's hard drive only if you
                  access the website using a computer. If you do not deactivate
                  or erase the cookie, each time you use the same computer to
                  access the website, our web servers will be notified of your
                  visit to the website and in turn we may have knowledge of your
                  visit and the pattern of your usage. Generally, we use cookies
                  to identify you and enable us to i) access your Registration
                  Information or Account Information so you do not have to
                  re-enter it; ii) gather statistical information about usage by
                  users; iii) research visiting patterns and help target
                  advertisements based on user interests; iv) assist our
                  partners to track user visits to the website and process
                  orders; and v) track progress and participation in promotions.
                  You can determine if and how a cookie will be accepted by
                  configuring the browser which is installed in the computer you
                  are using to access the website. If you choose, you can change
                  those configurations. By setting your preferences in the
                  browser, you can accept all cookies or you can choose to be
                  notified when a cookie is sent or you can choose to reject all
                  cookies. If you reject all cookies by choosing the
                  cookie-disabling function in your browser, you may be required
                  to re-enter information on the website more often and certain
                  features of the website may be unavailable.
                </p>

                <p className=" text-[1rem] mb-2 font-medium">MINORS</p>
                <p className="text-[0.9rem] mb-6 font-light text-[#666666]">
                  The website and their contents are not targeted to minors
                  (those under the age of 18) and we do not intend to sell any
                  of our products or services to minors. However, we have no way
                  of distinguishing the age of individuals who access our Site.
                  If a minor has provided us with personal information without
                  parental or guardian consent, the parent or guardian should
                  contact our Legal Department at the address set out in
                  paragraph D above to remove the information.
                </p>

                <p className=" text-[1rem] mb-2 font-medium">
                  PASSWORD SECURITY
                </p>
                <p className="text-[0.9rem] mb-6 font-light text-[#666666]">
                  We employ commercially reasonable security methods to prevent
                  unauthorized access to the website, to maintain data accuracy
                  and to ensure the correct use of the information we hold. For
                  registered users of the website, your Registration Information
                  and Account Information (if any) can be viewed and edited
                  through your account, which is protected by a password. We
                  recommend that you do not divulge your password to anyone. Our
                  personnel will never ask you for your password in an
                  unsolicited phone call or in an unsolicited email. If you
                  share a computer with others, you should not choose to save
                  your login information (e.g., user ID and password) on that
                  shared computer. Remember to sign out of your account and
                  close your browser window when you have finished your session.
                  No data transmission over the internet or any wireless network
                  can be guaranteed to be perfectly secure. As a result, while
                  we try to protect the information we hold for you, we cannot
                  guarantee the security of any information you transmit to us
                  and you do so at your own risk.
                </p>

                <p className=" text-[1rem] mb-2 font-medium">
                  CHANGES TO THIS PRIVACY POLICY
                </p>
                <p className="text-[0.9rem] mb-6 font-light text-[#666666]">
                  Any changes to this Privacy Policy will be communicated by us
                  posting an amended and restated Privacy Policy on the website.
                  Once posted on the website the new Privacy Policy will be
                  effective immediately. You agree that any information we hold
                  about you (as described in this Privacy Policy and whether or
                  not collected prior to or after the new Privacy Policy became
                  effective) will be governed by the latest version of the
                  Privacy Policy. Please visit the policy periodically to be
                  updated.
                </p>

                <p className=" text-[1rem] mb-2 font-medium">
                  USER DISCRETION AND OPT OUT
                </p>
                <p className="text-[0.9rem] mb-6 font-light text-[#666666]">
                  You agree and acknowledge that You are providing Your
                  Information out of Your free will. Subject to certain
                  exceptions prescribed by law and provided Elchemy can
                  authenticate Your identity, You can contact Elchemy at
                  info@Elchemy.com or send a mail to BizinBiz Technologies Pvt
                  Ltd Address: 3rd Floor, A50, Donear House, Cross Road Number 1, Near V R A
                  Reality Pvt Ltd, Andheri East, Mumbai, Mumbai Suburban, Maharashtra, India
                  400093
                  <ol className="list-decimal">
                    <li>
                      <p className="text-[0.9rem] mb-6 font-light text-[#666666]">
                        Access, verify, correct, update, amend, restrict, object
                        to, or later on withdraw Your consent to delete any
                        personal information Elchemy has about You.
                      </p>
                    </li>
                    <li>
                      <p className="text-[0.9rem] mb-6 font-light text-[#666666]">
                        Review the information Elchemy retains, how it has been
                        used, to whom Elchemy has disclosed such information to.
                      </p>
                    </li>
                    <li>
                      <p className="text-[0.9rem] mb-6 font-light text-[#666666]">
                        Opt to transfer Your personal data.
                      </p>
                    </li>
                    <li>
                      <p className="text-[0.9rem] mb-6 font-light text-[#666666]">
                        Change preferences regarding how Your personal
                        information is disclosed.
                      </p>
                    </li>
                    <li>
                      <p className="text-[0.9rem] mb-6 font-light text-[#666666]">
                        Notify Elchemy if You do not want Your data to be
                        processed anymore.
                      </p>
                    </li>
                    <li>
                      <p className="text-[0.9rem] mb-6 font-light text-[#666666]">
                        Notify Elchemy if You do not wish to receive further
                        communication from Elchemy.
                      </p>
                    </li>
                  </ol>
                </p>
                <p className=" text-[1rem] mb-2 font-medium">
                  GRIEVANCE OFFICER
                </p>
                <p className="text-[0.9rem] mb-6 font-light text-[#666666]">
                  We will respond to such requests in reasonable time within the
                  time limits established by the applicable law. In accordance
                  with the applicable laws, we reserve the right to charge you a
                  reasonable fee for the processing of any data access or
                  correction request. <br />
                  <br />
                  In the event that You opt out, You should neither visit the
                  Website nor use the services provided by Elchemy nor shall You
                  contact Elchemy. Further, Elchemy may not deliver products to
                  You, upon Your order, or Elchemy may deny You access from
                  using certain services offered on the Website.
                </p>
                <p className="text-[0.9rem] mb-6 font-light text-[#666666]">
                  If You find any discrepancies or have any grievances in
                  relation to the collection, storage, use, disclosure and
                  transfer of Your Personal Information under this Privacy
                  Policy or any terms of Elchemy 's Terms of Use and other terms
                  and conditions of Elchemy, please contact the designated
                  grievance officer under Information Technology Act, 2000 using
                  the details below:
                </p>
                <p className="text-[0.9rem] mb-2 font-light text-[#666666]">
                  Grievance Officer Name: Shobhit Jain
                </p>
                <p className="text-[0.9rem] mb-2 font-light text-[#666666]">
                  E-mail: info@elchemy.com
                </p>
                <p className="text-[0.9rem] mb-2 font-light text-[#666666]">
                  BizinBiz Technologies Pvt Ltd Address: 202-203, Lodha
                  Supremus, End of 11th Rd, Off Mahakali Caves Rd, Andheri East,
                  Mumbai, Maharashtra, India 400069
                </p>
                <p className="text-[0.9rem] mb-2 font-light text-[#666666]">
                  Telephone number: {PHONE_NUMBER_ONE.label}
                </p>
                <p className="text-[0.9rem] mb-2 font-light text-[#666666]">
                  Telephone number: {PHONE_NUMBER_TWO.label}
                </p>
                <p className="text-[0.9rem] mb-2 font-light text-[#666666]">
                  The details of the grievance officer may be changed by Us from
                  time to time by updating this Privacy Policy.
                </p>
              </div>
            </div>
          </div>
        </div>
      </>
    </>
  );
};

export default PrivacyPolicy;
